var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_3151",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_30_12",
    "data-name": "Component 30 \\u2013 12",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_29_1",
    "data-name": "Component 29 \\u2013 1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3, -2)",
    filter: "url(#Rectangle_3151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3151-2",
    "data-name": "Rectangle 3151",
    width: 44,
    height: 44,
    rx: 15,
    transform: "translate(3 2)",
    fill: "#15b5d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33623",
    "data-name": "Group 33623",
    transform: "translate(9.765 8.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33616",
    "data-name": "Group 33616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33615",
    "data-name": "Group 33615",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143072",
    "data-name": "Path 143072",
    d: "M24.772,23.329l-1.444-4.2A10.513,10.513,0,0,0,14.063,4.012,10.5,10.5,0,0,0,3.393,14.376a7.652,7.652,0,0,0-2.323,9.4L.075,26.672a1.368,1.368,0,0,0,1.288,1.811,1.377,1.377,0,0,0,.448-.075l2.895-.995a7.685,7.685,0,0,0,3.272.739h.012a7.641,7.641,0,0,0,6.178-3.142,10.534,10.534,0,0,0,4.339-1.062l4.2,1.444a1.636,1.636,0,0,0,.532.089,1.625,1.625,0,0,0,1.531-2.152ZM7.989,26.672H7.98a6.189,6.189,0,0,1-2.874-.714.74.74,0,0,0-.586-.046l-2.968,1.02,1.02-2.968a.74.74,0,0,0-.046-.586A6.17,6.17,0,0,1,3.53,16.225,10.542,10.542,0,0,0,12.318,24.9,6.154,6.154,0,0,1,7.989,26.672Zm15.349-2.714a.134.134,0,0,1-.148.034l-4.5-1.546a.74.74,0,0,0-.586.046,9.039,9.039,0,0,1-4.2,1.042h-.014a9.058,9.058,0,0,1-9.021-8.875A9.022,9.022,0,0,1,14.04,5.492a9.024,9.024,0,0,1,7.833,13.233.74.74,0,0,0-.046.586l1.546,4.5A.134.134,0,0,1,23.339,23.958Z",
    transform: "translate(0 -4.011)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33618",
    "data-name": "Group 33618",
    transform: "translate(8.745 6.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33617",
    "data-name": "Group 33617",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143073",
    "data-name": "Path 143073",
    d: "M189.65,139.512h-8.816a.74.74,0,1,0,0,1.48h8.816a.74.74,0,0,0,0-1.48Z",
    transform: "translate(-180.094 -139.512)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33620",
    "data-name": "Group 33620",
    transform: "translate(8.745 9.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33619",
    "data-name": "Group 33619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143074",
    "data-name": "Path 143074",
    d: "M189.65,202.183h-8.816a.74.74,0,1,0,0,1.48h8.816a.74.74,0,1,0,0-1.48Z",
    transform: "translate(-180.094 -202.183)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33622",
    "data-name": "Group 33622",
    transform: "translate(8.745 12.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33621",
    "data-name": "Group 33621",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143075",
    "data-name": "Path 143075",
    d: "M186.256,264.852h-5.423a.74.74,0,0,0,0,1.48h5.423a.74.74,0,0,0,0-1.48Z",
    transform: "translate(-180.093 -264.852)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage1);
export default __webpack_public_path__ + "static/media/Message1.8e9be9366efa16971da4c50344f441e2.svg";
export { ForwardRef as ReactComponent };